import EcoEmail, { EmailFieldsType } from 'eco-design/elements/eco-email';
import EcoBanner, { EcoBannerProps } from 'eco-design/sections/eco-banner-card';
import { useMemo } from 'react';
import EcoIconArrow from 'eco-design-micro/icons/eco-icon-arrow';
import moment from 'moment';
import { textTran } from 'eco-design/elements/eco-email/config';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import { useScheduledContent } from '@/utils/hooks/useScheduledContent';
import { useGlobal } from '@/utils/useGlobal';

const contactListIds = {
    eu: '1585617461',
    uk: '1372111406',
    de: '356112763',
    fr: '1615613479',
    it: '1004671813',
    es: '1212554384',
    jp: '503090051',
};

function BannerEmailB() {
    const { t } = useLang('theProduct.Banner');
    const { getSystemTime } = useGlobal();
    const { locale = 'us' } = getLocal();
    const fields = useMemo(() => {
        const date = moment(getSystemTime()).format('YYYY-MM-DD');

        const EU_Fields: EmailFieldsType[] = [
            { type: 'single', id: '31', value: 1, overwrite: true },
            { type: 'multiple', id: '7596', value: [49], overwrite: false },
            { type: 'multiple', id: '9690', value: [12], overwrite: false },
        ];
        switch (locale) {
            case 'eu':
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
            case 'uk':
                return [{ type: 'single', id: '4430', value: 1, overwrite: true }, ...EU_Fields];
            case 'de':
                return [{ type: 'single', id: '4425', value: 1, overwrite: true }, ...EU_Fields];
            case 'fr':
                return [{ type: 'single', id: '4428', value: 1, overwrite: true }, ...EU_Fields];
            case 'it':
                return [{ type: 'single', id: '4429', value: 1, overwrite: true }, ...EU_Fields];
            case 'es':
                return [{ type: 'single', id: '4426', value: 1, overwrite: true }, ...EU_Fields];
            case 'jp':
                return [
                    { type: 'single', id: '4431', value: 1, overwrite: true },
                    { type: 'single', id: '31', value: 1, overwrite: false },
                    { type: 'multiple', id: '12713', value: [3], overwrite: false },
                    { type: 'text', id: '12712', value: date, overwrite: false },
                ];
            default:
                return [{ type: 'single', id: '4427', value: 1, overwrite: true }, ...EU_Fields];
        }
    }, [locale]);

    const IS_JP = locale === 'jp';

    const textObj = textTran[locale] || textTran['us'];
    return (
        <>
            {IS_JP && (
                <div className="email-hot-box">
                    <EcoEmail
                        contactListId={[contactListIds[locale as keyof typeof contactListIds] ?? contactListIds.eu]}
                        source="WEB_NEW_PRODUCT_SUB"
                        fields={fields}
                        termsHtml={
                            locale === 'jp'
                                ? `EcoFlow の<a href="https://account.ecoflow.com/agreement/ja-jp/PrivacyPolicy.html" target="_blank">プライバシーポリシー</a>と<a href="https://account.ecoflow.com/agreement/ja-jp/TermsOfUse.html" target="_blank">利用規約</a>に同意します`
                                : undefined
                        }
                        tipsObj={{
                            placeholder: t('emailPlaceholder'),
                        }}
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'activity_submit',
                            button_name: textObj.btnText,
                            product_name: 'EcoFlow RAPID Mag',
                        }}
                        subscribeData={{
                            sector_name: t('title'),
                            entry_position: 1,
                        }}
                    />
                </div>
            )}
            {t('color') && <div className="kv-color">{t('color')}</div>}
        </>
    );
}
export default function Comp() {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.Banner');
    const { t: t2 } = useLang('theProduct');

    const IS_JP = locale === 'jp';
    const IS_EU = ['eu', 'uk', 'de', 'fr', 'it', 'es'].includes(locale);
    const IS_NA = ['us', 'ca'].includes(locale);
    const buy = useScheduledContent({
        '2025/06/24 15:00:00 GMT+8': t('presale'),
        '2025/07/15 15:00:00 GMT+8': t('buynow'),
    });

    const dataA: EcoBannerProps = {
        layout: 'top-center',
        pc: 'https://websiteoss.ecoflow.com/upload/image/1748414114907/kv.jpg',
        pad: IS_JP
            ? 'https://websiteoss.ecoflow.com/upload/image/1750407016790/kv-pad.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1750668839707/kv-m.jpg',
        h5: IS_JP
            ? 'https://websiteoss.ecoflow.com/upload/image/1750407016790/kv-pad.jpg'
            : 'https://websiteoss.ecoflow.com/upload/image/1750668839707/kv-m.jpg',
        label: t('label'),
        title: t('title'),
        desc: t('desc'),

        lChildren: (
            <span>
                {IS_EU ? buy : t('buynow')}
                <EcoIconArrow />
            </span>
        ),
        lType: 'text',
        lHref:
            IS_JP || IS_NA
                ? '#PowerSolution'
                : `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag`,
        lDataLayer:
            IS_JP || IS_NA
                ? {
                      event: 'uaEvent',
                      event_name: 'click_anchor',
                      position: t2('PowerSolution.title'),
                      button_name: t('buynow'),
                      __btn_id1: `${styles.comp} .__btn_l`,
                      __btn_id2: 'bannerBtnL',
                      __btn_type: 'common',
                  }
                : {
                      event: 'uaEvent',
                      event_name: 'buy',
                      product_name: 'EcoFlow RAPID Mag',
                      position: 'Collections_EcoFlow RAPID  Mag',
                      __btn_id1: `${styles.comp} .__btn_l`,
                      __btn_id2: `https://${locale}.ecoflow.com/collections/power-bank?sort_by=best-selling&filter.p.m.custom.filter_series=RAPID+Mag`,
                      __btn_type: 'href',
                  },
        rChildren: IS_JP ? t('video') : undefined,
        rType: 'text',
        rHref: IS_JP ? 'https://www.youtube.com/embed/vZSL4lCez18' : undefined,
        rDataLayer: {
            __btn_id1: `${styles.comp} .__btn_r`,
            __btn_id2: 'bannerBtnR',
            __btn_type: 'common',
        },
        rBtnIsYouToBe: true,

        childrenB: <BannerEmailB />,
        theme: 'black',
    };
    return (
        <div className={`${styles.comp} GtmModuleData-section`} data-section-id={'Banner'}>
            <EcoBanner {...dataA} />
        </div>
    );
}
